<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  created() {
    this.$ml.change(this.lang);
  },
  data() {
    return {
      lang: process.env.VUE_APP_LANG
    };
  }
};
</script>
<style lang="scss">
body {
  margin: 0;
}
#app {
  *,
  ::before,
  ::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // -webkit-tap-highlight-color: transparent;
  }
  a {
    color: $primary;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
